export interface Apikeys {
  status: string;
  google_oauth_client_id?: string;
  google_oauth_client_secret?: string;
  google_oauth_ios_client_id?: string;
  /** Apple Services ID (Sign in with Apple web client_id). */
  apple_client_id?: string;
  apple_redirect_uri?: string;
  /** Microsoft Entra ID Application (client) ID (Sign in with Microsoft). */
  microsoft_client_id?: string;
  stripe_pk_test?: string;
  stripe_pk_live?: string;
  gtag_config?: string;
  local_gtag_config?: string;
  /** Maps JavaScript / Places API (New) browser key. */
  google_maps_api_key?: string;
  sound_api_reg_key?: string;
  cloudflare_api_token?: string;
  /** Public string keys, plus JSON object blobs (e.g. fcm_google_services_json). */
  [key: string]: string | Record<string, unknown> | unknown[] | undefined;
}

export const apikeys: Apikeys = {"status":"success","google_oauth_ios_client_id":"732010702128-f5tumif52iisoksuoqrv3ebfbgs9rejr.apps.googleusercontent.com","fcm_google_services_json":{"project_info":{"project_number":"733951120578","project_id":"webddn-acekil-cc3b1","storage_bucket":"webddn-acekil-cc3b1.firebasestorage.app"},"client":[{"client_info":{"mobilesdk_app_id":"1:733951120578:android:6c00a3a6df28105f55d75b","android_client_info":{"package_name":"com.webddn.acekil"}},"oauth_client":[],"api_key":[{"current_key":"AIzaSyD4tescYzoigMqIEwuFrT3JZT-WCTz8OrU"}],"services":{"appinvite_service":{"other_platform_oauth_client":[]}}},{"client_info":{"mobilesdk_app_id":"1:733951120578:android:4a567ac853ceb64155d75b","android_client_info":{"package_name":"com.webddn.acekil.debug"}},"oauth_client":[],"api_key":[{"current_key":"AIzaSyD4tescYzoigMqIEwuFrT3JZT-WCTz8OrU"}],"services":{"appinvite_service":{"other_platform_oauth_client":[]}}}],"configuration_version":"1"},"google_oauth_client_id":"732010702128-jk7k391k8kn43nh185pvk3lrp4eip81q.apps.googleusercontent.com"};
